import { useState, useEffect } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useGame } from './hooks/useGame.js';
import { StartPage } from './pages/StartPage.js';
import { GamePage } from './pages/GamePage.js';
import { ResultsPage } from './pages/ResultsPage.js';
import { LeaderboardScreen } from './components/LeaderboardScreen.js';
import { AdminPage } from './pages/AdminPage.js';

function GameApp() {
  const navigate = useNavigate();
  const { state, startGame, beginPlaying, decide, submitDecisions, reset, toggleAiVsHuman } = useGame();
  const [playerName, setPlayerName] = useState('');
  const [playerEmail, setPlayerEmail] = useState('');

  // Trigger submission when phase hits submitting with all decisions ready
  useEffect(() => {
    if (state.phase === 'submitting' && state.decisions.length === 10) {
      submitDecisions(state.decisions);
    }
  }, [state.phase, state.decisions, submitDecisions]);

  if (state.phase === 'idle' || state.phase === 'loading' || state.phase === 'error') {
    return (
      <>
        {state.error && <div className="error-banner">{state.error}</div>}
        <StartPage
          onStart={(id) => startGame(id)}
          onLeaderboard={() => navigate('/leaderboard')}
          aiVsHuman={state.aiVsHuman}
          onToggleAiVsHuman={toggleAiVsHuman}
          loading={state.phase === 'loading'}
          playerName={playerName}
          playerEmail={playerEmail}
          onPlayerNameChange={setPlayerName}
          onPlayerEmailChange={setPlayerEmail}
        />
      </>
    );
  }

  if ((state.phase === 'intro' || state.phase === 'playing' || state.phase === 'submitting') && state.session) {
    return (
      <GamePage
        session={state.session}
        currentIndex={state.currentIndex}
        phase={state.phase}
        aiVsHuman={state.aiVsHuman}
        onBeginPlaying={beginPlaying}
        onDecide={decide}
      />
    );
  }

  if (state.phase === 'results' && state.results && state.session) {
    return (
      <ResultsPage
        results={state.results}
        sessionId={state.session.sessionId}
        playerName={playerName}
        playerEmail={playerEmail}
        onPlayAgain={reset}
        onViewLeaderboard={() => navigate('/leaderboard')}
      />
    );
  }

  return null;
}

export function App() {
  return (
    <Routes>
      <Route path="/leaderboard" element={<LeaderboardScreen standalone />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="*" element={<GameApp />} />
    </Routes>
  );
}
